<app-ion-common-header [id]="headerId" [labelBtnBack]="labelBtnBack" (backHeader)="backPage()" (focusHeader)="shownContent()"
  [title]="titlePage"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">

  <div class="content-scroll content-scroll--button-lg">

    <app-ion-common-label *ngIf="!checkStatusPage()"  labelStyle="display-rg" labelDescription="{{nameNative ? nameNative + ', ' : ''}}complete seu cadastro para investir" [label]="'É necessário completar alguns dados para começar a investir. É jogo rápido!'"></app-ion-common-label>
  
    <app-ion-common-label *ngIf="checkStatusPage()"  labelStyle="display-rg" labelDescription="{{nameNative}}, seu cadastro está quase completo!" [label]="'Avance para próxima etapa e confira seus dados para começar a investir.'"></app-ion-common-label>
  
    <div class="conent-center">
      <app-list-status [listStatus]="listStatus"></app-list-status>
    </div>

  </div>

</ion-content>

<div class="control-page fixed" [attr.aria-hidden]="ariaHidden">
  <app-ion-common-button label="Completar depois" (clickButton)="clickEnd()" typeButton="light"
    positionButton="block"></app-ion-common-button>
  <div class="border-top">
    <app-ion-common-button label="Completar cadastro" (clickButton)="clickNextPage()"
      positionButton="block"></app-ion-common-button>
  </div>
</div>

<app-loading-circle *ngIf="loading"></app-loading-circle>
<div class="sr-only" *ngIf="alertVoiceOver" aria-live="assertive">
  Carregando página
</div>
